







import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import ClientGroupDataGrid from '../components/client-group-data/client-group-data-grid.vue';

@Component({
  components: {
    PageTitle,
    ClientGroupDataGrid
  }
})
export default class ClientGroupData extends Vue {}
